export const isCreatedTarget = (target, section, id) =>
  target?.targetSection === section && Number(target?.createdId) === Number(id);

export const createPersistentTarget = (targetSection, recordId, source) =>
  ['Estadias', 'Mensualidades'].includes(targetSection)
    && ['creation', 'notification', 'salida'].includes(source)
    && Number(recordId) > 0
    ? { targetSection, createdId: Number(recordId), source }
    : null;

export const createCreatedTarget = (targetSection, createdId) =>
  createPersistentTarget(targetSection, createdId, 'creation');

export const createNotificationTarget = (targetSection, recordId) =>
  createPersistentTarget(targetSection, recordId, 'notification');

export const consumeCreatedTarget = (target, createdId) =>
  Number(target?.createdId) === Number(createdId) ? null : target;

export const keepCreatedTargetForSection = (target, section) =>
  target?.targetSection === section ? target : null;

export const getHighlightScrollBehavior = (matchMedia = window.matchMedia) =>
  matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'auto' : 'smooth';
